jQuery(document).ready(function($) {

  if ( $('.listactivitesmembres_select').length ) {

    var selected = $(".listactivitesmembres_select").val();

    $(".listactivitesmembres_cards").addClass("hidden");
    $(".listactivitesmembres_cards.card_"+selected).removeClass("hidden");

    $(".listactivitesmembres_select").change(function () {
        var selected = $(this).val();

        $(".listactivitesmembres_cards").addClass("hidden");
        $(".listactivitesmembres_cards.card_"+selected).removeClass("hidden");
    });  
} 
});